module.exports = __webpack_public_path__ + "static/media/ios-arrow-round-forward.c6315be0.svg";